module.exports = __webpack_public_path__ + "media/images/promo/championship/digits/0-e64634fa39f280f93a1b19a005104bf4.png";